import { render, staticRenderFns } from "./XUpload.vue?vue&type=template&id=4cd64ab8"
import script from "./XUpload.vue?vue&type=script&lang=js"
export * from "./XUpload.vue?vue&type=script&lang=js"
import style0 from "./XUpload.vue?vue&type=style&index=0&id=4cd64ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports